import React, { Component } from 'react'
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, message, Modal, notification } from 'antd'
import { getPremiumInfo, getPremiumInfoData } from '../../actions';
import { getlocationInfo } from '../../lib/fileUtils';
import { getCurrency, getMonthCount, getMonthCountDisplay, getPrice, serverApiEurope } from '../../lib/utils';
import LoadingSpinner from './Loading';
import PremiumCard from '../Premium/PremiumCard';
import PremiumPoints from '../Premium/PremiumPoints';
import ClickPremium from '../Premium/ClickPremium';

class PremiumPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            premiumInfo: undefined,
            selectedIndex: ('initIndex' in props) ? props.initIndex : 2,
            loadingPrices: true,
            isRecurring: false,
            options: [],
            errorObj: {}
        }
    }

    componentDidMount() {
        this.loadPrices();
        ///let local currencies load.
        setTimeout(() => {
            const currency = getCurrency();
            if (currency != 'USD') {
                this.setState({});
            }
        }, 700);
    }

    loadPrices = () => {
        const { productId, productIds } = this.props;
        const currency = getCurrency();
        const product = productId || 'prod_MlIhG2xDTbtQm8';

        const products = (productIds != null && productIds.length > 0) ? productIds : [product];
        const promises = [];
        for (const product of products) {
            promises.push(fetch(`${serverApiEurope}stripePricesForCheckout?currency=${currency}&product=${product}`));
        }
        Promise.all(promises)
            // fetch(`${serverApiEurope}stripePricesForCheckout?currency=${currency}&product=${product}`)
            .then(async (results) => {
                const resultArray = [];
                for (const result of results) {
                    const data = await result.json();
                    const optionsLoc = data['data'] || [];
                    resultArray.push(...optionsLoc);
                }
                // const data = await dataOrig.json();
                console.dir(resultArray);
                const optionsLoc = resultArray.sort((p1, p2) => p1.unit_amount - p2.unit_amount) || [];
                this.setState({
                    loadingPrices: false,
                    // options: isOnboard ? [optionsLoc[1]] : (isPromo ? optionsLoc.slice(1) : optionsLoc)
                    options: optionsLoc
                });
            }).catch(err => {
                notification.error({
                    message: 'There was an error loading prices. Please try again.',
                    description: '',
                    duration: null
                });
            })

        // fetch(`${serverApiEurope}stripePricesForCheckout?currency=${currency}&product=${product}`)
        //     .then(async (dataOrig) => {
        //         const data = await dataOrig.json();
        //         console.dir(data);
        //         const optionsLoc = data['data'] && data['data'].sort((p1, p2) => p1.unit_amount - p2.unit_amount) || [];
        //         this.setState({ loadingPrices: false, options: optionsLoc, isRecurring: data['data'] && data['data'].length > 2 });
        //     }).catch(err => {
        //         notification.error({
        //             message: 'There was an error loading prices. Please try again.',
        //             description: '',
        //             duration: null
        //         });
        //     })
    }

    choosePremium = (selectedIndex) => {
        this.setState({ selectedIndex });
    }

    render() {
        const { isOffer, mainTitle, bottomInfo, subtitle, discountParent, hasTrial } = this.props;
        const { selectedIndex, options, loadingPrices, isRecurring } = this.state;
        const premiumInfoLoc = getPremiumInfoData() || {};
        let discountFin;
        if (discountParent) {
            discountFin = discountParent;
        } else {
            discountFin = isOffer ? 50 : 1;
        }
        console.dir(options);
        console.dir(selectedIndex);
        console.dir(options[selectedIndex]);
        return (
            <div>
                <div style={{ padding: '2em' }}>
                    {/* Premium features */}
                    {/* {isOffer && <h3 className='text-center' style={{ whiteSpace: 'pre-wrap' }}>🎉 {mainTitle || `Special offer 50% Off`}</h3>} */}
                    <div className='text-center'><h3>Enjoy unlimited features & save up to <span className='bg-red'>9 hours per week</span></h3></div>
                    <br />
                    <PremiumPoints />
                    {loadingPrices ? <div><LoadingSpinner /> </div> : <div>
                        <div className='card-div'>
                            {options.map((option, index) => (
                                <div key={index}>
                                    <PremiumCard option={option} index={index} isOffer={isOffer} selectedIndex={selectedIndex}
                                        options={options}
                                        discount={(discountParent != null && discountParent > 0) ? discountParent :
                                            (option.type != 'recurring' ? 50 : discountFin)}
                                        choosePremium={this.choosePremium} />
                                </div>
                            ))}
                        </div>
                        <div className='text-center' style={{ marginBottom: '8px' }}>
                            <ClickPremium isOffer={isOffer} option={options[selectedIndex]} hasTrial={hasTrial} />
                            {/* <Button className={`third-button`} onClick={this.clickPremium}>
                                Continue
                            </Button> */}
                        </div>
                        {options.length > 0 && <div className='text-center'>
                            <p>{hasTrial ? 'Try 7 days for free. After that ' : ''}{getPrice(options[selectedIndex])}&#47;{getMonthCountDisplay(options[selectedIndex], selectedIndex)} {getMonthCount(options[selectedIndex], selectedIndex) > 200 ? '' : 'months'}{(!isOffer && options[selectedIndex].type == 'recurring') && <span>, cancel any time</span>}</p>
                        </div>}
                        {/* {options.length > 0 && options[selectedIndex].type == 'recurring' &&
                            <div className='mt-2 text-center'><h5>{(premiumInfoLoc['bottom'] ?? 'Cancel anytime').replace('{appstore}', '')}</h5></div>
                        } */}
                        {/* {bottomInfo && <div className='mt-2 text-center'><h4>{bottomInfo}</h4></div>} */}
                    </div>}
                </div>
                <style jsx>
                    {`
                    .discount {
                        background: green;
                        position: absolute;
                        left: 0;
                        top: 0;
                        border-radius: 4px;
                        font-size: 12px;
                        padding: 2px 4px;
                    }
                    .bg-red {
                        background: #E03145;
                        color: white;
                        padding: 8px 16px;
                        border-radius: 12px;
                    }
                .card-div {
                    display: flex;
                    justify-content: center;
                }
            `}
                </style>
            </div >
        )
    }
}

PremiumPage.propTypes = {
    productId: PropTypes.string,
    productIds: PropTypes.array,
    initIndex: PropTypes.number,
    discountParent: PropTypes.number,
    isOffer: PropTypes.bool,
    hasTrial: PropTypes.bool,
    mainTitle: PropTypes.string,
    bottomInfo: PropTypes.string,
    subtitle: PropTypes.string,
    userDetails: PropTypes.object,
}
const mapStateToProps = (state) => {
    return {
        userDetails: state.userDetails,
        // loadingState: state.loadingState,
    }
}
export default connect(mapStateToProps, null)(PremiumPage);